var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FE4D43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21272 15.0086C10.0168 14.574 10.8573 14.2521 11.7654 14.0968C12.6538 13.9448 13.5198 14.0149 14.3815 14.244C15.7759 14.6149 16.968 15.3278 17.9356 16.3954C18.437 16.9488 18.8456 17.5696 19.0686 18.2949C19.1612 18.5961 19.0852 18.8073 18.8617 18.8746C18.67 18.9323 18.4695 18.7815 18.3714 18.5235C17.9349 17.3758 17.1516 16.5169 16.1381 15.8488C15.3035 15.2987 14.395 14.9324 13.4074 14.7881C12.4095 14.6423 11.4554 14.8437 10.528 15.2163C9.64265 15.572 8.86681 16.0876 8.20287 16.7695C7.69104 17.2951 7.30284 17.901 7.05926 18.5967C6.96898 18.8546 6.81743 18.9244 6.56512 18.8376C6.36542 18.7688 6.26607 18.5603 6.35393 18.3427C6.76032 17.3359 7.32176 16.4378 8.19166 15.7589C8.25677 15.7081 8.30565 15.6364 8.36208 15.5745C8.5944 15.309 8.88596 15.1323 9.21272 15.0086Z",
    fill: "#750301"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50442 10.4771C6.45435 9.76904 7.06789 9.14953 7.82695 9.19891C8.51911 9.24395 9.0463 9.74331 9.03127 10.4638C9.01443 11.2689 8.43063 11.7308 7.72642 11.7294C7.01996 11.7281 6.44928 11.0871 6.50442 10.4771Z",
    fill: "#750300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9879 11.6758C17.5659 11.8251 17.1916 11.6897 16.8763 11.4281C16.5202 11.1328 16.3688 10.7391 16.4455 10.2604C16.5908 9.35325 17.4036 9.03866 18.1332 9.26695C18.7726 9.46703 19.1086 10.1804 18.8954 10.8421C18.7756 10.9227 18.7332 11.0426 18.7234 11.1793L18.7235 11.179C18.6083 11.2146 18.564 11.3209 18.4978 11.4054L18.4982 11.4051C18.2979 11.4386 18.1092 11.4938 17.9879 11.6758Z",
    fill: "#750300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBad);
export default __webpack_public_path__ + "static/media/bad.c06507982eada4a3a4a634f191328ad2.svg";
export { ForwardRef as ReactComponent };